import React from "react";
import "./index.css";
import Home from "./routes/Home";
import CustomCursor from "./components/CustomCursor/CustomCursor";
import { Analytics } from "@vercel/analytics/react";

function App() {
  return (
    <>
      <CustomCursor />
      <Home />
      <Analytics />
    </>
  );
}

export default App;
